<div class="auth-wrapper-login">
  <div class="auth-panel-left" [class.auth-panel-left--dev]="!produccion">
    <span class="auth-blob auth-blob-1"></span>
    <span class="auth-blob auth-blob-2"></span>
    <span class="auth-blob auth-blob-3"></span>
    <span class="auth-blob auth-blob-4"></span>

    <div class="auth-brand-panel">
      <div class="auth-brand-logo">
        <img src="/assets/image/icon/logo-tsi-tres.png" alt="TSI" />
      </div>
      <h1 class="auth-brand-title">{{ nombreProyecto }}</h1>
      <p class="auth-brand-subtitle">Plataforma de reportes programados<br>y monitoreo SQL</p>

      <div class="auth-brand-divider"></div>

      <div class="auth-brand-features">
        <div class="auth-brand-feature">
          <span class="feat-dot"></span> Reportes programados en tiempo real
        </div>
        <div class="auth-brand-feature">
          <span class="feat-dot"></span> Integración con Power BI
        </div>
        <div class="auth-brand-feature">
          <span class="feat-dot"></span> Historial de ejecuciones
        </div>
        <div class="auth-brand-feature">
          <span class="feat-dot"></span> Monitoreo de uso por empresa
        </div>
      </div>
    </div>
  </div>

  <div class="auth-panel-right" [class.auth-panel-right--dev]="!produccion">
    <div class="auth-panel-bg">
      <span class="auth-deco auth-deco-tl"></span>
      <span class="auth-deco auth-deco-br"></span>
    </div>

    <div class="auth-form-wrapper">
      <div>
        <div *ngIf="!produccion">
          <span class="auth-test-badge">
            <span class="badge-dot"></span> ENTORNO DE PRUEBAS
          </span>
        </div>

        <div class="auth-card">
          <h2 class="auth-card-title">Bienvenido de vuelta</h2>
          <p class="auth-card-subtitle">Ingresa tus credenciales para continuar</p>

          <form [formGroup]="authForm" (ngSubmit)="authUser()">

            <div class="auth-field" [class.has-error]="validacion('ruc')">
              <span class="auth-field-icon"><fa-icon [icon]="faBuilding"></fa-icon></span>
              <input type="text" formControlName="ruc" class="auth-input" placeholder=" " maxlength="11"
                id="f-ruc" autocomplete="off">
              <label for="f-ruc" class="auth-label">RUC</label>
            </div>
            <p *ngIf="validacion('ruc')" class="auth-error">Ingresar RUC</p>

            <div class="auth-field" [class.has-error]="validacion('nomuser')">
              <span class="auth-field-icon"><fa-icon [icon]="faUser"></fa-icon></span>
              <input type="text" formControlName="nomuser" class="auth-input" placeholder=" " id="f-user"
                autocomplete="off">
              <label for="f-user" class="auth-label">Usuario</label>
            </div>
            <p *ngIf="validacion('nomuser')" class="auth-error">Ingresar usuario</p>

            <div class="auth-field" [class.has-error]="validacion('clave')">
              <span class="auth-field-icon"><fa-icon [icon]="faLock"></fa-icon></span>
              <input [type]="showPassword() ? 'text' : 'password'" formControlName="clave"
                class="auth-input" placeholder=" " id="f-clave" autocomplete="new-password">
              <label for="f-clave" class="auth-label">Contraseña</label>
              <button type="button" class="auth-toggle-pw" (click)="togglePassword()">
                <fa-icon [icon]="showPassword() ? faEye : faEyeSlash"></fa-icon>
              </button>
            </div>
            <p *ngIf="validacion('clave')" class="auth-error">Ingresar clave</p>

            <p *ngIf="errorMsg()" class="auth-error" style="margin-top:6px;">{{ errorMsg() }}</p>

            <button type="submit" class="auth-btn mt-2" [class.auth-btn--red]="!produccion" [disabled]="loading()">
              {{ loading() ? 'Ingresando…' : 'Ingresar' }}
            </button>
          </form>

          <div class="auth-version">
            <span>v{{ versionApp }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
